import React from 'react';
import styles from './Map.module.css';

import map from '../../../images/Map/Map.png'
import marker from '../../../images/Map/Marker.png'


const Map = () => {
    return (
        <div id='section3' className={styles.container}>
            <h1 className={styles.header}>Інтерактивна <span style={{color: 'red'}}>мапа</span></h1>
            <div className={styles.row}>
                <iframe className={styles.map} src="https://www.google.com/maps/d/embed?mid=1u3Xchv2VU0__1s5JzCf3rK40pWjNf-0&ehbc=2E312F"
                        width="557" height="581"></iframe>
                <div className={styles.column}>
                    <h2 className={styles.column_h2}> <span style={{color: 'red'}}>
                        Безкоштовна доставка</span> при оренді <span
                        style={{borderBottom: '3px solid red', paddingBottom: '5px'}}>від 7 днів </span> будь-якого
                        комплекту!
                    </h2>
                    <img className={styles.marker} src={marker} alt="Marker"/>
                    <h2 className={styles.column_h2}
                        style={{textAlign: 'left'}}><span className={styles.span_inline}>Самовивіз
                        безкоштовно</span> </h2>
                    <p>Ви можете самостійно приїхати до магазину для отримання, повернення чи заміни консолі.</p>
                    <p className={styles.p2}>Ми працюємо щодня з 09:00 до 20:00.</p>
                    <div className={styles.span_wrapper}>
                        <span className={styles.span}>Забір обладнання не включено до вартості доставки</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Map;